<template>
  <div class="stpe_one order_list" id="orderlist">
    <div class="step_title">
      <span
        v-for="item in orderType"
        :class="{ act: item.selected }"
        @click="checkOrderType(item)"
        >{{ item.text }}</span
      >
    </div>
    <span v-show="orderType[0].selected">
      <div class="service_category">
        <!-- <div class="step_title">服务类目</div> -->
        <div class="service_category_info" style="padding-bottom: 6px">
          <div class="info_settype jiaju">
            <div class="type_name"><span class="xing">*</span>商品类目</div>
            <div class="type_content">
              <div
                class="category"
                @click="checkToClass(item)"
                :class="{ isCheck: item.isSelected }"
                v-for="(item, index) in categoryCommodities"
                :key="index"
              >
                <div class="jiaju">
                  <img :src="item.icon" alt />
                </div>
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="info_settype" v-if="serviceTypeList.length">
            <div class="type_name type-title">
              <span class="xing">*</span>服务类型
            </div>
            <div class="type_content service-type-info">
              <div
                class="service_type"
                v-for="(item, index) in serviceTypeList"
                @click="checkedServiceType(item)"
                :class="{ selected: item.isSelected }"
              >
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div
            v-if="serviceTypeList.length"
            class="type-tips"
            style="
              position: static;
              margin-left: 83px;
              margin-top: 6px;
              height: auto;
            "
          >
            {{ tipsText }}
          </div>
          <div style="display: none"></div>
        </div>
      </div>
      <div class="step_one_main">
        <div class="service_category" v-show="commodityInfo">
          <div class="step_title">客户信息</div>
          <div class="service_category_info">
            <!-- 地址识别 -->
            <div class="address-module">
              <div class="address-title">
                <img src="@/assets/img/xiadan_zhinengtianxie.png" alt />
                智能地址填写
                <span>复制粘贴一整段地址，自动识别姓名、地址和电话</span>
              </div>
              <div class="address-module-inp">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请将复制的整段地址粘贴在此处"
                  v-model="addressBefore"
                ></el-input>
              </div>
              <div>
                <el-button
                  class="identify"
                  :disabled="!addressBefore"
                  @click="parseClick"
                  >智能识别</el-button
                >
                <el-button style="margin-left: 8px" @click="addressBefore = ''"
                  >清空</el-button
                >
              </div>
            </div>

            <div class="kehu-box">
              <div class="info_settype">
                <div class="type_name"><span class="xing">*</span>客户姓名</div>
                <div class="type_content">
                  <el-input
                    v-model="$store.state.orderData.customerName"
                    :maxlength="100"
                    @input="iscustomerInfo"
                    placeholder="请输入"
                  ></el-input>
                </div>
              </div>
              <div class="radio_input">
                <div class="type_name"><span class="xing">*</span>有无电梯</div>
                <el-radio
                  v-model="$store.state.orderData.isLift"
                  @change="iscustomerInfo"
                  label="true"
                  border
                  >有</el-radio
                >
                <el-radio
                  v-model="$store.state.orderData.isLift"
                  @change="iscustomerInfo"
                  label="false"
                  border
                  >无</el-radio
                >
              </div>
              <div
                class="info_settype"
                v-if="$store.state.orderData.isLift == 'false'"
              >
                <div class="type_name"><span class="xing">*</span>楼层数</div>
                <div class="type_content">
                  <el-input
                    class="floor-num"
                    type="number"
                    v-model="$store.state.orderData.floorsNumber"
                    placeholder="请输入"
                  ></el-input>
                </div>
                <div class="radio_tishi">
                  （报价仅适用层高3米及3米内，超过3米您需要接受师傅适当加价）
                </div>
              </div>
            </div>

            <div class="kehu-box">
              <div class="info_settype">
                <div class="type_name"><span class="xing">*</span>客户手机</div>
                <div class="type_content">
                  <el-input
                    v-model="$store.state.orderData.customerPhone"
                    placeholder="请输入"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    maxlength="11"
                    @input="iscustomerInfo"
                  ></el-input>
                </div>
              </div>
              <div class="info_settype address">
                <div class="type_name"><span class="xing">*</span>联系地址</div>
                <div class="type_content">
                  <el-cascader
                    v-model="$store.state.orderData.areaCode"
                    :options="cityOptions"
                    :props="cityCodeProps"
                    placeholder="选择所在城市"
                    @change="checkCity($store.state.orderData.areaCode)"
                    clearable
                    filterable
                  ></el-cascader>
                </div>
                <div class="type-tips" style="left: 83px; bottom: -23px">
                  {{ areaTips }}
                </div>
              </div>
              <!-- <div class="info_settype"> -->
              <div class="type_content" style="margin-left: 8px">
                <el-input
                  v-model="$store.state.orderData.address"
                  @input="iscustomerInfo"
                  placeholder="请输入详细地址"
                ></el-input>
              </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
        <div v-show="!goodsInfo">
          <div
            class="service_category"
            v-for="(item, index) in $store.state.orderData.orderItems"
            :key="index"
            @click="whatNumber(item, index)"
          >
            <div class="step_title">
              商品信息{{ index + 1 }}
              <svg
                @click="removeCommodity(item)"
                class="icon icona_xiadan_delete"
                aria-hidden="true"
                v-if="
                  $store.state.orderData.orderItems.length == 1 ? false : true
                "
              >
                <use xlink:href="#icona_xiadan_delete" />
              </svg>
            </div>
            <div class="service_category_info goods-detail">
              <div class="goods-info">
                <div class="info_settype">
                  <div class="type_name commodity">
                    <span class="xing">*</span>商品图
                  </div>
                  <div
                    class="type_content"
                    :class="{ img_delete: item.fileList.length != 0 }"
                  >
                    <div
                      class="library-box"
                      v-if="libraryList.rows.length > 0"
                      @click="
                        libraryList.rows.length > 0
                          ? (goodsLibrary = true)
                          : (goodsLibrary = false)
                      "
                    ></div>
                    <svg
                      class="icon icona_xiadan_delete"
                      aria-hidden="true"
                      @click="deleteImg(index)"
                    >
                      <use xlink:href="#icona_xiadan_delete" />
                    </svg>
                    <a-upload
                      :action="baseApl + '/common/common/upload_file'"
                      listType="picture-card"
                      :fileList="item.fileList"
                      @preview="handlePreview"
                      @change="handleChange"
                      :beforeUpload="beforeUpload"
                      :disabled="libraryList.rows.length > 0"
                      class="upload"
                    >
                      <div v-if="item.fileList.length < 1">
                        <a-icon type="plus" />
                        <div class="ant-upload-text">图片</div>
                      </div>
                    </a-upload>
                    <a-modal
                      :visible="previewVisible"
                      :footer="null"
                      @cancel="handleCancel"
                    >
                      <img
                        alt="example"
                        style="width: 100%"
                        :src="previewImage"
                      />
                    </a-modal>
                  </div>
                </div>

                <div class="info_settype" style="margin-top: 13px">
                  <div class="type_name">安装视频</div>
                  <div class="type_content">
                    <div
                      class="upload-video"
                      :class="{ video_delete: item.videoList.length != 0 }"
                    >
                      <svg
                        class="icon iconz_pop_close"
                        aria-hidden="true"
                        @click="deleteVideo(index)"
                      >
                        <use xlink:href="#iconz_pop_close" />
                      </svg>
                      <a-upload
                        :action="baseApl + '/common/common/upload_file'"
                        :videoList="item.videoList"
                        @change="handleVideoChange"
                        :beforeUpload="beforeVideoUpload"
                        class="video_up"
                      >
                        <div v-if="item.videoList.length < 1">
                          <a-button class="upload_video">
                            <a-icon type="upload" />安装视频（选传）
                            <span class="tishi">视频不超过500M</span>
                          </a-button>
                        </div>
                      </a-upload>
                    </div>
                  </div>
                </div>
              </div>

              <div class="goods-text">
                <div class="info_settype">
                  <div class="type_name">
                    <span class="xing">*</span>商品类别
                  </div>
                  <div class="type_content">
                    <el-cascader
                      v-model="item.goodsTypeId"
                      :options="goodsTypeList"
                      :props="goodsTypeProps"
                      @change="checkGoodsType"
                      placeholder="请选择"
                      clearable
                      filterable
                    ></el-cascader>
                  </div>
                </div>

                <div class="info_settype">
                  <div class="type_name">
                    <span class="xing">*</span>商品名称
                  </div>
                  <div class="type_content">
                    <el-input
                      v-model="item.name"
                      placeholder="请输入"
                    ></el-input>
                  </div>
                </div>

                <div class="info_settype">
                  <div class="type_name">包装方式</div>
                  <div class="type_content">
                    <el-input
                      v-model="item.packingMethod"
                      placeholder="请输入"
                    ></el-input>
                  </div>
                </div>

                <div class="info_settype">
                  <div class="type_name">商品描述</div>
                  <div class="type_content">
                    <el-input
                      v-model="item.description"
                      placeholder="请输入需要师傅注意的事项"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="input_number">
                <span class="xing">*</span>商品套数
                <el-input-number
                  class="number_input"
                  v-model="item.count"
                  @change="calculatePrice"
                  step-strictly
                  :min="1"
                  :max="999"
                  label="描述文字"
                ></el-input-number>
              </div>
            </div>
          </div>

          <div class="add_commodity" @click="addCommodity()">
            <svg class="icon icona_xiadan_addshangpin" aria-hidden="true">
              <use xlink:href="#icona_xiadan_addshangpin" /></svg
            >添加商品
          </div>

          <div class="service_category">
            <div class="service_category_info baozhuang_info">
              <div class="info_settype" style="margin-bottom: 8px">
                <div class="type_name">
                  <span class="xing">*</span>订单总体积m³
                </div>
                <div class="type_content">
                  <el-input
                    v-model="totalVolume"
                    placeholder="请输入家居体积"
                    maxlength="11"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                  ></el-input>
                </div>
              </div>
              <div class="info_settype baozhuang">
                <div class="type_name"><span class="xing">*</span>包装件数</div>
                <div class="type_content">
                  <el-input-number
                    class="number_input"
                    v-model="$store.state.orderData.packingCount"
                    @change="inputNumChange"
                    step-strictly
                    :min="1"
                    :max="999"
                    label="描述文字"
                  ></el-input-number>
                </div>
              </div>
              <div style="display: none"></div>
            </div>
          </div>

          <div class="step_one_price" v-if="priceshow">
            <div class="one_tab">
              <div class="one_price_name">平台服务费：</div>
              <div class="one_price">¥0.00</div>
            </div>
            <div class="one_tab">
              <div class="one_price_name">保险费：</div>
              <div class="one_price">¥0.00</div>
            </div>
            <div class="one_tab">
              <div class="one_price_name">师傅服务费：</div>
              <div class="one_price">¥0.00</div>
            </div>
            <div class="one_tab">
              <div class="one_price_name" @click="calculatePrice()">
                应付总额：
              </div>
              <div class="one_price one_total">¥0.00</div>
            </div>
          </div>

          <div class="step_one_price" v-else>
            <div
              class="one_tab"
              v-for="(item, index) in $store.state.priceList.orderServiceFees"
              :key="index"
            >
              <div class="one_price_name">{{ item.name }}：</div>
              <div class="one_price">¥{{ item.fee }}</div>
            </div>
            <div class="one_tab">
              <div class="one_price_name">师傅服务费：</div>
              <div class="one_price">
                ¥{{ $store.state.priceList.workerFee }}
              </div>
            </div>
            <div class="one_tab">
              <div class="one_price_name" @click="calculatePrice()">
                应付总额：
              </div>
              <div class="one_price one_total">
                ¥{{ $store.state.priceList.totalFee }}
              </div>
            </div>
          </div>

          <el-button class="nextStep" @click="nextStep()">下一步</el-button>
        </div>
      </div>
    </span>
    <batch-order
      v-show="orderType[1].selected"
      ref="batchOrder"
      orderType="GENERAL"
    ></batch-order>
    <!-- 商品库弹窗 -->
    <el-dialog
      title="商品图片"
      :visible.sync="goodsLibrary"
      width="30%"
      class="complaint goodsLibrary"
      @close="initializeLibrary()"
    >
      <div>
        <div class="complaint-img">
          <a-upload
            :action="baseApl + '/common/common/upload_file'"
            listType="picture-card"
            @change="goodsHandleChange"
            :fileList="fileList"
            :beforeUpload="beforeUpload"
          >
            <div>
              <a-button class="upload_video">
                <a-icon type="upload" />上传图片
              </a-button>
            </div>
          </a-upload>
        </div>
        <div class="library-title">商品图库</div>
        <div class="library-condition type_content">
          <el-cascader
            v-model="libraryNum"
            :options="goodsTypeLists"
            :props="goodsTypeProps"
            @change="checkLibraryType"
            placeholder="请选择"
            clearable
          ></el-cascader>
          <el-input
            placeholder="请输入商品名称"
            class="library-search"
            v-model="libraryName"
            @change="getGoodsLibraryList"
          >
            <i
              slot="prefix"
              @click="getGoodsLibraryList()"
              class="el-input__icon el-icon-search"
            ></i>
          </el-input>
        </div>
        <div class="libraryList">
          <div
            class="item"
            v-for="(item, index) in libraryList.rows"
            :key="index"
            @click="checkGoods(item)"
          >
            <img :src="item.imgUrl" alt />
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Bus from "./../../utils/bus.js";
import { setTimeout } from "timers";
import AddressParse from "address-parse";
import batchOrder from "@/components/user/modules/batchOrder";
import { arithmeticMultiply, arithmeticDivide } from "@/utils/util";

export default {
  components: {
    batchOrder,
  },
  data() {
    return {
      orderType: [
        { text: "单笔下单", selected: true },
        { text: "批量下单", selected: false },
      ],
      serviceTypeList: [],
      categoryCommodities: [],
      commodityInfo: false,
      goodsInfo: true,
      radio: "true", //必须事字符串
      previewVisible: false,
      previewImage: "",
      fileList: [],
      videoList: [],
      commodityType: "",
      orderItems: [
        {
          fileList: [],
          videoList: [],
          goodsTypeId: "",
          name: "",
          count: "",
          packingMethod: "",
          description: "",
        },
      ],
      num: 0,
      areaTips: "",
      cityValue: [],
      cityOptions: [],
      goodsTypeList: [],
      goodsTypeLists: [], // 商品库
      goodsTypeProps: { expandTrigger: "hover", value: "id", label: "name" },
      cityCodeProps: { expandTrigger: "hover", value: "code", label: "name" },
      goodsNum: 0,
      webToken: {
        WEB_TOKEN: Cookies.get("token"),
      },
      priceshow: true,
      priceList: {
        orderServiceFees: [],
      },
      deleteBtn: false,
      baseApl: process.env.VUE_APP_BASE_API,
      goodsLibrary: false, // 控制商品库显示隐藏
      libraryList: {
        rows: [],
      }, // 商品库数据
      libraryName: "", // 商品库搜索条件
      libraryNum: "", // 商品库商品id
      totalVolume: "1",
      tipsText: "", // 服务类型提示

      addressBefore: "",
      addressAfter: {},
      addressAfterCode: [],
    };
  },
  // 接收注入的数据
  inject: ["reload"],
  activated() {
    var _this = this;
    var data = {
      url: "stepOne",
      step: 1,
      finish: "finish",
    };
    Bus.$emit("val", data);
    this.orderInit();
    _this.$store.state.defaultUrl = "";
    // if (Cookies.get("token") != undefined) {
    // 获取城市
    this.$fetch(`/common/api/area`).then((res) => {
      if (res.code == 0) {
        _this.cityOptions = res.data;
      } else {
        this.$message(res.message);
      }
    });

    if (this.$store.state.orderData.goodsTypeId) this.getServiceType();
    // 获取商品类目
    this.$fetch(`/common/api/goods_type/top_class`).then((res) => {
      if (res.code == 0) {
        res.data.map((i) => {
          i.isSelected = false;
          if (i.id == this.$store.state.orderData.goodsTypeId) {
            i.isSelected = true;
          }
        });
        _this.categoryCommodities = res.data;
      } else {
        this.$message(res.message);
      }
    });

    if (Cookies.get("token") != undefined) {
      _this.getGoodsLibraryList();
    }
    if (this.$store.state.priceList.orderServiceFees.length != 0) {
      this.priceshow = false;
    }
    this.iscustomerInfo();
  },
  watch: {
    totalVolume(e) {
      // if (this.isRealNum(e)) {
        // if (Number(val) <= 0) {
        //   this.$store.state.orderData.totalVolume = "";
        //   this.totalVolume = "";
        // }
        // if (val.indexOf(".") != -1) {
        //   this.$store.state.orderData.totalVolume = val.split(".")[0];
        //   this.totalVolume = val.split(".")[0];
        // }

        if (e.toString().split(".").length == 3) {
          this.$store.state.orderData.totalVolume = e.toString().substr(0, e.length - 1);
          this.totalVolume = e.toString().substr(0, e.length - 1);
        } else {
          if (e.toString().split(".")[1]) {
            // this.markupPrice = Math.floor(e * 10000) / 10000;
            this.$store.state.orderData.totalVolume = arithmeticDivide(
              Math.floor(arithmeticMultiply(e.toString(), 100)),
              100
            );
            this.totalVolume = arithmeticDivide(
              Math.floor(arithmeticMultiply(e.toString(), 100)),
              100
            );
          }
        }
        this.calculatePrice();
      // } else {
      //   this.totalVolume = "";
      // }
    },
  },
  methods: {
    // // 保留两位小数
    // watchNumber(e) {
    //   console.log(e);
    //   if (e.split(".").length == 3) {
    //     this.$store.state.orderData.totalVolume = e.substr(0, e.length - 1);
    //   } else {
    //     if (e.split(".")[1]) {
    //       // this.markupPrice = Math.floor(e * 10000) / 10000;
    //       this.$store.state.orderData.totalVolume = arithmeticDivide(
    //         Math.floor(arithmeticMultiply(e, 100)),
    //         100
    //       );
    //     }
    //   }
    //   this.$forceUpdate();
    //   this.calculatePrice();
    // },
    // 切换订单类型
    checkOrderType(e) {
      this.$alert("更换下单方式会导致已添加的商品丢失，确定切换吗？", "提示", {
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback: (action) => {
          if (action == "confirm") {
            // this.orderInits()
            // this.$router.go(0);
            this.orderType.map((i) => {
              i.selected = false;
            });
            e.selected = true;
          }
        },
      });
    },
    // 解析点击
    parseClick() {
      if (!this.addressBefore) {
        return;
      }
      this.$store.state.orderData.areaCode = [];
      let orderData = this.$store.state.orderData.areaCode;
      const result = AddressParse.parse(this.addressBefore);
      console.log(result);
      this.addressAfter = result.length ? result[0] : {};
      let address = this.addressAfter;
      let all = this.cityOptions;
      this.$store.state.orderData.customerName = address.name;
      this.$store.state.orderData.customerPhone = address.mobile;
      this.$store.state.orderData.address = address.details;

      this.addressAfterCode = [];
      let prov = null;
      let city = null;
      let area = null;
      prov = all.find((item) => {
        return (
          item.name.indexOf(address.province) > -1 ||
          address.province.indexOf(item.name) > -1
        );
      });
      city = prov
        ? prov.children.find((item) => {
            return (
              item.name.indexOf(address.city) > -1 ||
              address.city.indexOf(item.name) > -1
            );
          })
        : null;
      area = city
        ? city.children.find((item) => {
            return (
              item.name.indexOf(
                address.area.substr(0, address.area.length - 1)
              ) > -1 || address.area.indexOf(item.name) > -1
            );
          })
        : null;
      console.log(orderData);
      prov ? orderData.push(prov.code) : "";
      city ? orderData.push(city.code) : "";
      area ? orderData.push(area.code) : "";

      this.checkCity(orderData);
      console.log(orderData);
    },
    // 获取服务类型
    getServiceType() {
      let _this = this;
      // 获取服务类型
      // this.$fetch(`/common/api/service_type`).then(res => {
      this.$fetch(`/common/api/service_type/list_by_good_type`, {
        goodTypeId: this.$store.state.orderData.goodsTypeId,
      }).then((res) => {
        if (res.code == 0) {
          for (let i of res.data) {
            i.isSelected = false;
            if (i.id == _this.$store.state.orderData.serviceType) {
              i.isSelected = true;
              _this.commodityInfo = true;
            }
          }
          if (this.$store.state.orderData.goodsTypeId)
            _this.serviceTypeList = res.data;
          // _this.tipsText = res.data[0].description;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 判断输入值是否为数字
    isRealNum(val) {
      // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，
      if (val === "" || val == null) {
        return false;
      }
      if (!isNaN(val)) {
        //对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
        //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
        return true;
      } else {
        return false;
      }
    },
    // 判断客户信息是否填全
    iscustomerInfo() {
      let userinfo = this.$store.state.orderData;
      if (
        !!userinfo.customerName &&
        !!userinfo.customerPhone &&
        !!userinfo.areaCode[userinfo.areaCode.length - 1] &&
        !!userinfo.address &&
        !!userinfo.isLift
      ) {
        this.goodsInfo = false;
        this.getGoodsType();
      }
    },
    // 判断是否重新下单
    orderInit() {
      if (this.$store.state.orderData.customerName == "") {
        // this.$router.go(0);
        this.commodityInfo = false;
        this.goodsInfo = true;
        this.categoryCommodities.map((i) => {
          i.isSelected = false;
        });
        this.serviceTypeList.map((i) => {
          i.isSelected = false;
        });
      }
    },
    // 获取商品类别
    getGoodsType() {
      let _this = this;
      // 获取商品类别
      this.$fetch(`/common/api/goods_type`, {
        areaCode:
          this.$store.state.orderData.areaCode[
            this.$store.state.orderData.areaCode.length - 1
          ],
      }).then((res) => {
        if (res.code == "0") {
          // _this.goodsTypeList = res.data[0].children;
          console.log(res);
          _this.goodsTypeLists = res.data;
          res.data.map((i) => {
            if (i.id == _this.$store.state.orderData.goodsTypeId) {
              i.children.map((j, index) => {
                if (!j.children) delete i.children.splice(index, 1);
              });
              _this.goodsTypeList = i.children;
            }
          });
        } else {
          this.$message(res.message);
        }
      });
    },
    // 选择商品类目
    checkToClass(item) {
      if (this.commodityInfo) {
        this.$alert("更换服务类目会导致已添加的商品丢失，确定切换", "提示", {
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          callback: (action) => {
            if (action == "confirm") {
              this.$router.go(0);
            }
          },
        });
      } else {
        var orderData = this.$store.state.orderData;
        orderData.orderItems.map((i) => {
          i.goodsTypeId = null;
        });
        this.categoryCommodities.map((i) => {
          i.isSelected = false;
        });
        item.isSelected = true;
        this.$store.state.orderData.goodsTypeId = item.id;
        this.getGoodsType();
        this.getServiceType();
      }
    },
    // 获取商品库数据
    getGoodsLibraryList() {
      this.$post(
        `/user/api/goods/list?goodsTypeId=${
          !this.libraryNum ? "" : this.libraryNum
        }&keyWord=${this.libraryName}&pageIndex=1&pageNum=999`
      ).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.libraryList = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 初始化商品库数据
    initializeLibrary() {
      this.libraryNum = "";
      this.getGoodsLibraryList();
    },
    // 选择商品库商品
    checkGoods(item) {
      this.$store.state.orderData.orderItems[this.goodsNum].goodsTypeId =
        item.goodsTypeId;
      this.$store.state.orderData.orderItems[this.goodsNum].name = item.name;
      this.$store.state.orderData.orderItems[this.goodsNum].fileList.push({
        thumbUrl: item.imgUrl,
        name: item.name,
        status: "done",
        uid: "-1",
        response: { data: { url: item.imgUrl } },
      });
      this.goodsLibrary = false;
      this.calculatePrice();
    },
    // 切换服务类型
    checkedServiceType(item) {
      this.$message.closeAll();
      if (this.$store.state.orderData.goodsTypeId == "") {
        this.$message.error("请先选择商品类目");
        return;
      }
      this.commodityInfo = true;
      for (let i of this.serviceTypeList) {
        i.isSelected = false;
      }
      item.isSelected = !item.isSelected;
      this.tipsText = item.description;
      this.$store.state.orderData.takeDeliveryFee = item.takeDeliveryFee;
      this.$store.state.orderData.serviceType = item.id;
      this.calculatePrice();
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    // 判断下标是第几个
    whatNumber(item, index) {
      this.goodsNum = index;
    },
    // 判断上传是否为图片
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("图片只能上传jpg、png格式");
      }
      //   const isLt2M = file.size / 1024 / 1024 < 2
      //   if (!isLt2M) {
      //     this.$message.error('Image must smaller than 2MB!')
      //   }

      return isJPG;
    },
    // 判断上传是否为视频
    beforeVideoUpload(file) {
      const isVideo = file.type === "video/mp4";
      if (!isVideo) {
        this.$message.error("视频只能上传mp4格式");
      }
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$message.error("视频不能超过100M");
        this.$store.state.orderData.orderItems[this.goodsNum].videoList = [];
      }

      return isVideo && isLt100M;
    },
    // 删除图片
    deleteImg(index) {
      console.log(index);
      this.$store.state.orderData.orderItems[index].fileList = [];
    },
    // 删除视频
    deleteVideo(index) {
      this.$store.state.orderData.orderItems[index].videoList = [];
      $(".upload-video").on("click", ".iconz_pop_close", function () {
        $(this)
          .siblings(".video_up")
          .find(".ant-upload-list-item-done")
          .remove();
      });
    },
    // 商品信息上传图片
    handleChange({ fileList }) {
      if (
        fileList[0].type === "image/jpeg" ||
        fileList[0].type === "image/png"
      ) {
        this.$store.state.orderData.orderItems[this.goodsNum].fileList =
          fileList;
      } else {
        this.$store.state.orderData.orderItems[this.goodsNum].fileList = [];
      }
    },
    // 商品库上传图片
    goodsHandleChange({ fileList }) {
      let list = [];
      if (
        fileList[0].type === "image/jpeg" ||
        fileList[0].type === "image/png"
      ) {
        list.push(fileList[fileList.length - 1]);
        this.fileList = list;
        this.$store.state.orderData.orderItems[this.goodsNum].fileList =
          this.fileList;
        this.goodsLibrary = false;
      } else {
        this.fileList = [];
        this.$store.state.orderData.orderItems[this.goodsNum].fileList = [];
      }
    },
    handleVideoChange(info) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      fileList = fileList.map((file) => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });
      // 判断上传视频大小
      if (fileList[0].size / 1024 / 1024 < 100) {
        if (
          fileList[0].type === "video/mp4" &&
          !fileList[0].size / 1024 / 1024 < 100
        ) {
          this.$store.state.orderData.orderItems[this.goodsNum].videoList =
            fileList;
        } else {
          return;
        }
      } else {
        return;
      }
    },
    inputNumChange(value) {
      this.$store.state.orderData.packingCount = value;
      this.calculatePrice();
    },
    // 获取城市说明文字
    getAreaTips(item) {
      this.$fetch(`/common/api/goods_type/goods_area_description`, {
        areaCode: item[item.length - 1],
      }).then((res) => {
        if (res.code == 0) {
          this.areaTips = res.data;
        }
      });
    },
    // 选择城市
    checkCity(item) {
      var orderData = this.$store.state.orderData;
      // 判断该区域是否开通服务
      this.$fetch(`/common/api/area/servce_agent_area`, {
        goodsTypeId: orderData.goodsTypeId,
        areaCode: item[item.length - 1],
      }).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.getAreaTips(item);
          this.iscustomerInfo();
        } else {
          this.$alert("该区域暂未开通服务，无法下单", "提示", {
            confirmButtonText: "确定",
            type: "warning",
            callback: () => {
              orderData.areaCode = "";
            },
          });
        }
      });
      this.calculatePrice();
    },
    // 选择商品类别
    checkGoodsType(value) {
      this.$store.state.orderData.orderItems[this.goodsNum].goodsTypeId =
        value[value.length - 1];
      this.calculatePrice();
    },
    // 商品库选择类别
    checkLibraryType(value) {
      this.libraryNum = value[value.length - 1];
      this.getGoodsLibraryList();
    },
    // 判断是否是整数
    isInteger(num) {
      if (!isNaN(num) && num % 1 === 0) {
        return true;
      } else {
        return false;
      }
    },
    // 进入步骤二
    nextStep() {
      this.$message.closeAll();
      var orderData = this.$store.state.orderData;
      var myreg = /^1[123456789]\d{9}$/;
      if (orderData.customerName == "") {
        this.$message.error("请输入客户姓名");
        return;
      }

      if (!myreg.test(orderData.customerPhone)) {
        this.$message.error("请输入合法手机号");
        return;
      }

      if (orderData.areaCode == "") {
        this.$message.error("请选择所在城市");
        return;
      }
      if (orderData.address == "") {
        this.$message.error("请输入详细地址");
        return;
      }
      if (orderData.isLift == "") {
        this.$message.error("请选择有无电梯");
        return;
      }
      if (orderData.isLift == "false" && !orderData.floorsNumber) {
        this.$message.error("请输入楼梯层数");
        return;
      }
      for (let i of orderData.orderItems) {
        if (i.fileList.length != 0) {
          i.imgUrl = i.fileList[0].response.data.url;
        }
        if (i.videoList.length != 0) {
          i.installVideoUrl = i.videoList[0].response.data.url;
        }
        if (i.imgUrl == "") {
          this.$message.error("请上传商品图片");
          return;
          break;
        }
        if (i.goodsTypeId == "") {
          this.$message.error("请选择商品类别");
          return;
          break;
        }
        if (i.name == "") {
          this.$message.error("请输入商品名称");
          return;
          break;
        }
      }
      if (
        !orderData.totalVolume
      ) {
        // if (orderData.totalVolume == "0" || orderData.totalVolume == "") {
        this.$message.error("请输入的体积");
        return;
      }
      if (orderData.packingCount == "0") {
        this.$message.error("包装件数不能为0");
        return;
      }
      if (this.$store.state.priceList.workerFee == 0) {
        this.$message.error("商品类目价格维护中，该类目暂时不能下单");
        orderData.orderItems.map((i) => {
          i.goodsTypeId = "";
        });

        return;
      }
      this.$router.push({ path: "/placeorder/steptwo" });
    },
    // 添加新的商品
    addCommodity() {
      this.$store.state.orderData.orderItems.push({
        fileList: [], //图片list
        videoList: [], //视频list
        imgUrl: "", //视频地址
        installVideoUrl: "", //视频地址
        goodsTypeIdList: [], //商品类别id数组
        goodsTypeId: "", //商品类别id
        name: "", //商品名称
        count: "1", //商品数量
        packingMethod: "", //包装方式
        description: "", // 商品描述
      });
      this.calculatePrice();
    },
    // 删除商品
    removeCommodity(item) {
      var _this = this;
      this.$confirm("确认删除商品信息，删除后将无法恢复。", "", {
        confirmButtonText: "继续删除",
        cancelButtonText: "点错了",
        type: "warning",
      })
        .then(() => {
          _this.$store.state.orderData.orderItems.remove(item);
          this.calculatePrice();
        })
        .catch(() => {});
    },
    // 计算价格
    calculatePrice() {
      var _this = this;
      var orderData = this.$store.state.orderData;
      orderData.totalVolume = _this.totalVolume;
      var orderItems = [];
      for (let i of orderData.orderItems) {
        orderItems.push({
          name: i.name,
          count: i.count,
          goodsTypeId: i.goodsTypeId,
        });
      }

      this.$post(`/order/api/order/price`, {
        goodsTypeId: orderData.goodsTypeId,
        serviceType: orderData.serviceType,
        areaCode: orderData.areaCode[orderData.areaCode.length - 1],
        totalVolume: orderData.totalVolume,
        orderItems: orderItems,
        count: orderData.packingCount,
      }).then((res) => {
        if (res.code == 0) {
          _this.priceshow = false;
          _this.$store.state.priceList = res.data;
        } else {
          // this.$message(res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "./_step_one.scss";
</style>
<style lang="scss" scoped>
.step_title {
  justify-content: flex-start;
  color: #909399;
  font-weight: 500;
  margin-top: 10px;
  span {
    cursor: pointer;
    border-bottom: 1px solid transparent;
  }
  span + span {
    margin-left: 40px;
  }
  .act {
    color: #2f3133;
    border-bottom: 1px solid #3455d3;
  }
}
/deep/.el-input__icon {
  line-height: 32px;
}
#orderlist {
  .service_category {
    margin-top: 0;
  }
  .radio_input {
    &/deep/.el-radio.is-bordered {
      height: 30px !important;
      padding: 8px 12px 0 10px;
    }
  }
  .address {
    position: relative;
  }
  .type_content {
    flex-wrap: wrap;
    width: auto;
    .service_type {
      margin-top: 6px;
    }
    &/deep/.el-cascader {
      height: 30px;
      line-height: 30px;
    }

    // & /deep/ .number_input input {
    //   width: 153px !important;
    // }
  }
  & /deep/ .goodsLibrary .library-condition .el-input input {
    width: 100% !important;
  }
  & /deep/ .library-condition {
    .el-cascader {
      line-height: 30px;
    }
    .el-input__icon {
      line-height: 32px;
    }
  }
  &/deep/.el-message-box__btns .el-button--primary {
    &:hover {
      color: #fff;
    }
  }
  &/deep/.type_content {
    .el-input input {
      height: 30px !important;
      width: 240px !important;
    }
    .number_input input {
      width: 153px !important;
      height: 40px !important;
    }
    .floor-num input {
      width: 72px !important;
    }
  }
  &/deep/.goods-info {
    .ant-upload-list-picture-card-container {
      width: 60px;
      height: 60px;
    }
    .library-box {
      width: 60px;
      height: 60px;
      position: absolute;
      cursor: pointer;
    }
    .upload {
      .ant-upload.ant-upload-select-picture-card {
        border: 1px dashed #909399;
        border-radius: 2px;
        width: 60px;
        height: 60px;

        .anticon {
          font-size: 20px;
        }

        .ant-upload-text {
          font-size: 14px;
          height: 14px;
          line-height: 1;
        }
      }

      .ant-upload.ant-upload-select-picture-card:hover {
        border: 1px dashed #3455d3;

        .anticon {
          color: #3455d3;
        }

        .ant-upload-text {
          color: #3455d3;
          font-size: 14px;
          height: 14px;
          line-height: 1;
        }
      }

      .ant-upload-list-picture-card .ant-upload-list-item {
        width: 60px;
        height: 60px;
      }

      .ant-upload-list-item-info {
        width: 100%;

        & > span {
          width: 100%;
          height: 100%;
        }
      }

      .ant-upload-list-picture-card .ant-upload-list-item-info {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
  .address-module {
    border-bottom: 1px dashed #dcdfe6;
    margin-bottom: 19px;
    padding-bottom: 20px;
    .address-title {
      color: #3455d3;
      font-size: 14px;
      display: flex;
      align-items: center;
      span {
        color: #909399;
        font-size: 12px;
        margin-left: 12px;
      }
      img {
        width: 20px;
        height: 21px;
        padding-top: 1px;
        margin-right: 8px;
      }
    }
    .address-module-inp {
      height: 50px;
      margin-top: 11px;
      margin-bottom: 12px;
      &/deep/textarea {
        resize: none;
        height: 50px;
        border-radius: 0;
        &:focus,
        &:hover {
          border-color: #3455d3 !important;
        }
      }
    }
    &/deep/.el-button {
      width: 81px;
      height: 30px;
      border-color: #bec0c6;
      color: #5e6066;
      font-size: 12px;
      &.identify {
        background: #3455d3;
        border-color: #3455d3;
        color: #fff;
      }
      &.is-disabled {
        background: #9fade1 !important;
        color: #fff;
        border-color: #9fade1;
        &:focus,
        &:hover {
          color: #fff !important;
          border-color: #bec0c6 !important;
        }
      }
    }
  }
}
</style>
